import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TheATeamColorsData from "../../js/theATeamData";
import { Animatespin, HeadingCom, TheATeamCom } from "../../components/index";
import localimgpath from "../../js/localimgpath";
import Functions from "./index.function";
const TheATeam = () => {
  const { isLoading, settings, TheATeamData, handleTeamId } = Functions();
  return (
    <div className="bg-primary xs:py-5 sm:py-6 lg:pt-10">
      <div className="lg:px-5 xl:px-10 xs:px-3 xs:pb-5 sm:px-6 sm:pb-6  m-auto">
        <HeadingCom to={"/team"} title={"The Team"} />
      </div>
      <div className="">
        {isLoading ? (
          <Animatespin />
        ) : (
          <Slider {...settings}>
            {TheATeamData?.teams?.map((slide, index) => (
              <div
                key={`${index}`}
                className={`lg:py-16 ${
                  TheATeamData?.teams?.length >= 4
                    ? ""
                    : "sm:pr-5 lg:pr-8 xl:pr-14"
                }`}
              >
                <TheATeamCom
                  onClick={() =>
                    handleTeamId(
                      slide?.id,
                      TheATeamColorsData[index % TheATeamColorsData.length]
                        .bgcolor
                    )
                  }
                  image={`${localimgpath.teamAvatar}/${slide?.avatar}`}
                  title={slide?.name}
                  bgcolor={
                    TheATeamColorsData[index % TheATeamColorsData.length]
                      .bgcolor
                  }
                  position={slide?.designation?.name}
                  location={`${slide?.city?.city}. ${slide?.country?.country}`}
                />
              </div>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default TheATeam;
